import { Spinner } from "@/components/ui/spinner";

type Props = {
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onClick: () => void;
};

export function ViewMoreButton({
  hasNextPage,
  isFetchingNextPage,
  onClick,
}: Props) {
  if (!hasNextPage) return null;
  return (
    <div
      className="text-muted flex h-[24px] w-full cursor-pointer items-center justify-center rounded-[8px] bg-neutral-100 px-2 py-4 text-center text-xs leading-normal font-bold transition-colors duration-200 hover:bg-neutral-200"
      onClick={onClick}
    >
      {isFetchingNextPage ? (
        <div className="flex h-full items-center justify-center">
          <Spinner size="sm" className="stroke-primary!" />
        </div>
      ) : (
        "View More"
      )}
    </div>
  );
}
